import { common } from './common'

export const local = {
    ...common,
    api: {
        ...common.api, 
        json: {
            ...common.api.json,
            cocart: 'https://flagowa2020.createit.dev/wp-json/cocart/v1/',
            wc: 'https://flagowa2020.createit.dev/wp-json/wc/v3/',
            wp: 'https://flagowa2020.createit.dev/wp-json/wp/v2/'
        }
    }
}
